module.exports = "<fr-checkbox on-change=\"$ctrl.change($event, $index)\" value=\"item.value\" ng-repeat=\"item in $ctrl.checkItems\" label=\"item.label\" ng-class=\"$ctrl.class || '' \"></fr-checkbox>"


//////////////////
// WEBPACK FOOTER
// ./~/@front10/healthcare-book/src/app/common/checkbox-group/checkbox-group.html
// module id = 582
// module chunks = 0